export default "__VITE_ASSET__C2d$rME9__"